// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1btLl","largestCol":"styles_largestCol__1Gjsf","smallestCol":"styles_smallestCol__2Adso"};